import React from 'react';

const AboutPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="space-y-12">
        <section>
          <h1 className="font-heading text-5xl font-bold text-brand-primary mb-4">
            About Primatif
          </h1>
          <h2 className="font-heading text-4xl font-semibold text-brand-heading mb-4">
            Our Philosophy
          </h2>
          <p className="text-lg leading-relaxed text-brand-text">
            In today&apos;s market, technology isn&apos;t just a department;
            it&apos;s the engine of your business. But harnessing its full
            potential requires bridging the gap between technical execution and
            strategic vision. Primatif was founded on a simple premise: to
            provide clear, hands-on, and business-focused technology consulting
            that delivers tangible results.
          </p>
          <p className="text-lg leading-relaxed mt-4 text-brand-text">
            We believe in a partnership approach. Whether we&apos;re building
            software from the ground up, optimizing a process, or analyzing your
            data, we embed ourselves in your objectives to function as a
            seamless extension of your team.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-4xl font-semibold text-brand-heading mb-4">
            Meet the Founder: Key Clark
          </h2>
          <p className="text-lg leading-relaxed text-brand-text">
            I&#39;m Key, the founder and principal consultant at Primatif. As a
            lifelong technologist and software engineer, I&#39;ve dedicated my
            career to not just building things, but building the right things.
            My experience spans the full lifecycle of technology—from initial
            research and development to enterprise-level risk management and
            process architecture.
          </p>
          <p className="text-lg leading-relaxed mt-4 text-brand-text">
            I started Primatif to offer a more agile and direct consulting
            model. My role is to serve as your dedicated tech expert, whether
            that means acting as a hands-on project lead, a bridge between your
            technical and executive teams, or a strategic advisor helping you
            navigate the future.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-4xl font-semibold text-brand-heading mb-4">
            What We Do: Our Core Services
          </h2>
          <ul className="space-y-6">
            <li>
              <h3 className="font-heading text-2xl font-semibold text-brand-amber tracking-wider">
                Software Engineering &amp; Development
              </h3>
              <p className="text-lg text-brand-text">
                We manage the entire software lifecycle, from prototyping and
                R&D to full-scale deployment, modernization of legacy systems,
                and cloud migration.
              </p>
            </li>
            <li>
              <h3 className="font-heading text-2xl font-semibold text-brand-amber tracking-wider">
                Technology Business Management
              </h3>
              <p className="text-lg text-brand-text">
                We align technology with your core business objectives. This
                includes developing enterprise architecture, creating clear
                technology roadmaps, and implementing effective risk management.
              </p>
            </li>
            <li>
              <h3 className="font-heading text-2xl font-semibold text-brand-amber tracking-wider">
                Analytics and Data Science
              </h3>
              <p className="text-lg text-brand-text">
                We help you turn raw data into a strategic asset. Our services
                range from exploratory market research to building out
                effective, scalable data systems.
              </p>
            </li>
            <li>
              <h3 className="font-heading text-2xl font-semibold text-brand-amber tracking-wider">
                Generative AI Integration
              </h3>
              <p className="text-lg text-brand-text">
                We guide businesses in leveraging modern AI tools to optimize
                workflows, create custom assistants, and enhance creative and
                operational tasks.
              </p>
            </li>
            <li>
              <h3 className="font-heading text-2xl font-semibold text-brand-amber tracking-wider">
                Hiring and Team Building
              </h3>
              <p className="text-lg text-brand-text">
                We assist in building high-performing technical teams by
                providing in-depth technical screenings and custom skill
                verification challenges.
              </p>
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default AboutPage;
